<template>
    <div >
		<h1 class="text-muted mb-4">
			<vue-fontawesome class="mr-2" size="2" icon="shopping-bag"></vue-fontawesome>
			Sales
		</h1>			
        <div>
			<div class="d-flex justify-content-between">
				<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
						<li class="nav-item">
							<a class="nav-link active" 
								id="pills-home-tab" 
								data-toggle="pill" 
								href="#pills-home" 
								role="tab" 
								aria-controls="pills-home" 
								aria-selected="true">
								Sales
							</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" 
								id="pills-returns-tab" 
								data-toggle="pill" 
								href="#pills-returns" 
								role="tab" 
								aria-controls="pills-returns" 
								aria-selected="false"
								@click=getReturns()>
								Returns
							</a>
						</li>
						<li class="d-none nav-item">
							<a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false">Contact</a>
						</li>								
				</ul>				
			</div>									
			<div class="tab-content" id="pills-tabContent">
				<div class="tab-pane fade show active" 
					id="pills-home" 
					role="tabpanel" 
					aria-labelledby="pills-home-tab">
					<div class="d-flex p-2 mb-4">
							<span class="p-2 font-weight-bold" v-if="sales">
								<span class="text-muted">Found</span> {{sales.length}}
							</span>
							<div class="mr-2">
								<button class="btn btn-outline-success" 
									@click="getSales()">
									<vue-fontawesome icon="refresh"></vue-fontawesome>
									Refresh
								</button>
							</div>															
							<div class="dropdown">
								<a class="btn btn-outline-success dropdown-toggle" 
									href="#" role="button" id="dropdownMenuLink" 
									data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >									
									<vue-fontawesome class="mr-2" icon="filter"></vue-fontawesome>filter									
								</a>
								
								<div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
										<div class="form-group d-flex justify-content-between">
											<label class="p-2">Search</label>
											<input type="text" class="col-8 form-control" v-model="search"> 
										</div> 	
										<div class="form-group d-flex justify-content-between">
											<label >Since</label>
											<select class="col-8 form-control" v-model="date_range">
												<option value=1>today</option>
												<option value=2>yesterday</option>
												<option value=7>last 7 days</option>
												<option value=14>last 14 days</option>
												<option value=30>last 30 days</option>
												<option value=90>last 3 months</option>
											</select>
										</div>											
										<div class="form-group d-flex justify-content-between">
											<label class="p-2">From</label>
											<input type="date" name="bday" max="3000-12-31" 
											min="1000-01-01" class="col-8 form-control" v-model="from_date"> 
										</div> 
										<div class="form-group d-flex justify-content-between">
											<label class="p-2">To</label>
											<input type="date" name="bday" max="3000-12-31" 
											min="1000-01-01" class="col-8 form-control" v-model="to_date"> 
										</div> 
										<div class="ml-2 d-flex justify-content-end">
											<button class="btn btn-outline-success"  @click="getSales()">get sales</button>
										</div>	
								</div>
							</div>
							<div class="ml-2">
								<button class="btn btn-outline-success" 
									@click="$exportTable('salesTable','sales.csv')">
									<vue-fontawesome class="mr-2" icon="file-excel-o"></vue-fontawesome>									
									Export
								</button>	
							</div>
					</div>
					<!-- TABLE AND DEPENDENCIES -->
					<div class="rounded shadow border border-light p-2">
						<div class="bg-light">
							<!-- pagination top-->
							<div class="d-flex justify-content-end" v-if="sales.length > 100">
								<button class="btn" @click="prevPage"
									:disabled="pageNumber == 0">
									<i class="arrow left"></i>
								</button>
								<span class="p-3">{{pageNumber + 1}} / {{pageCount}}</span>
								<button class="btn" @click="nextPage"
									:disabled="(pageNumber+1) == pageCount">
									<i class="arrow right"></i>
								</button>
							</div>
						</div>					
						<table class="table table-borderless table-responsive-sm" id="salesTable">
							<thead>
								<tr>
									<th scope="col">Date</th>
									<th scope="col">Order number</th>
									<th scope="col">Customer</th>
									<th scope="col">Via</th>
									<th scope="col">total products</th>
									<th scope="col">total cost</th>
									<th scope="col">total payments</th>
									<th scope="col"></th>
								</tr>
							</thead>																	
							<tbody v-if="sales && sales.length">
								<tr v-for="(sale,index) in paginatedData" :key="index">
									<td scope="row">{{sale.date | dateformat}}</td>
									<td>{{sale.orderNumber}}</td>
									<td>{{sale.customerId | customer(customers)}}</td>
									<td>{{sale.via}}</td>
									<td>{{totalItems(sale.products) | intcomma}}</td>
									<td>{{totalCost(sale.products) | intcomma}}</td>
									<td>{{totalPayment(sale.payments) | intcomma}}</td>
									<div class="p-3">
										<a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Actions
                                        </a>
										<span class="p-2 dropdown-menu rounded shadow border-0" aria-labelledby="dropdownMenuLink">                                                                                                                                   
											<router-link class="dropdown-item cursor-pointer" 
												:to="{ name: 'saleDetail', params: { sale_id: sale.id }}">
												<vue-fontawesome class="cursor-pointer" icon="ellipsis-v"></vue-fontawesome>
												Receipt detail
											</router-link>                                                                                                                               									
                                        </span>
									</div>
								</tr>														
							</tbody>					
						</table>
						<div class="p-3 d-flex justify-content-center"
							v-if="sales && ! sales.length && $hasPermission('VIEW_SALES')">
							<span class="p-2">No records to show since</span>
							<div class="form-group d-flex justify-content-between">								
									<select class="form-control" v-model="date_range">
										<option value=1>today</option>
										<option value=2>yesterday</option>
										<option value=7>last 7 days</option>
										<option value=14>last 14 days</option>
										<option value=30>last 30 days</option>
										<option value=90>last 3 months</option>
									</select>
							</div>
						</div>
						<div class="p-3 d-flex justify-content-center"
							v-if="sales && ! sales.length && ! $hasPermission('VIEW_SALES')">							
							<h2>
								<i class="fa fa-shield" aria-hidden="true"></i>
							</h2>
							<span class="p-2">You are not authorized to view this page</span>
						</div>
						<div class="p-3 d-flex justify-content-center"
							v-if="! sales">
							<div class="spinner-border p-3 m-5" role="status">
								<span class="sr-only">Loading...</span>
							</div>
						</div>	
						<!-- pagination bottom -->
						<div class="d-flex justify-content-end" v-if="sales.length > 100">
							<button class="btn" @click="prevPage"
								:disabled="pageNumber == 0">
								<i class="arrow left"></i>
							</button>
							<span class="p-3">{{pageNumber + 1}} / {{pageCount}}</span>
							<button class="btn" @click="nextPage"
								:disabled="(pageNumber+1) == pageCount">
								<i class="arrow right"></i>
							</button>
						</div>	
					</div>		
					<!-- modals -->
					<!-- Button trigger modal -->
					<button type="button" id="receipt-modal-button" class="d-none btn" data-toggle="modal" data-target="#ReceiptModal">
						Launch receipt modal
					</button>
					
					<!-- Modal -->
					<div class="modal fade" id="ReceiptModal" tabindex="-1" role="dialog" aria-labelledby="ReceiptModal" aria-hidden="true">
						<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
						<div class="modal-content" v-if="receipt_modal_data">
							<div class="modal-header border-0">
							<h5 class="modal-title font-weight-bold" >Receipt No. {{receipt_modal_data.id}}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							</div>
							<div class="modal-body">								
								<div class="d-flex justify-content-between">
									<!-- deatils -->
									<section class="p-3" style="border-right: solid 1px darkgray ; min-width: 200px;">										
										<span class="d-flex flex-column">
											<label class="font-weight-bold">Date:</label>										
											<p class="ml-2">{{receipt_modal_data.date | dateformat}}</p>
										</span>
										<span class="d-flex flex-column">
											<label class="font-weight-bold">Order Number:</label>
											<span class="ml-2">{{receipt_modal_data.orderNumber}}</span>
										</span>
										<span class="d-flex flex-column">
											<label class="font-weight-bold">Customer:</label>
											<span class="ml-2">{{receipt_modal_data.customerId}}</span>
										</span>
										<span class="d-flex flex-column">
											<label class="font-weight-bold">Via</label>
											<span class="ml-2">{{receipt_modal_data.via}}</span>
										</span>																			
									</section>
									<!-- Items sold and payments -->
									<section class="p-3 d-flex justify-content-center flex-wrap" style="height:50vh; overflow-y:scroll">										
										<!-- items sold -->
										<div class="table-responsive">
											<h3 class="text-muted">Items sold</h3>
											<table class="table table-borderless">													
												<thead>
													<tr>												
													<th scope="col">Product</th>
													<th scope="col">Variant</th>
													<th scope="col">Qty</th>												
													<th scope="col">Price</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(product,index) in receipt_modal_data.products" :key="index">												
														<td>{{product.name}}</td>
														<td>{{product.variant_id}}</td>
														<td>{{product.qty}}</td>
														<td>{{product.total | intcomma}}</td>
													</tr>												
												</tbody>
											</table>
										</div>	
										<!-- payments-->
										<div class="table-responsive">
												<h3 class="text-muted">Payments</h3>
												<table class="table table-borderless">													
													<thead>
														<tr>																										
														<th scope="col">Type</th>
														<th scope="col">Transaction Id</th>
														<th scope="col">Amount</th>																										
														</tr>
													</thead>
													<tbody>
														<tr v-for="(payment,index) in receipt_modal_data.payments" :key="index">																											
															<td>{{payment.type}}</td>
															<td>{{payment.transaction_id}}</td>
															<td>{{payment.amount | intcomma}}</td>															
														</tr>												
													</tbody>
												</table>
											</div>										
									</section>

									<div></div>
								</div>
							</div>
							<div class="modal-footer border-0">
									<span class="d-flex justify-content-between">
										<label class="font-weight-bold">Items:</label>
										<span class="ml-2">{{totalItems(receipt_modal_data.products) | intcomma}}</span>
									</span>	
									<span class="d-flex justify-content-between">
										<label class="font-weight-bold">Total cost:</label>
										<span class="ml-2">{{totalCost(receipt_modal_data.products) | intcomma}}</span>
									</span>
									<span class="d-flex justify-content-between">
										<label class="font-weight-bold">Total payed:</label>											
										<span class="ml-2">{{totalPayment(receipt_modal_data.payments) | intcomma}}</span>
									</span>
							</div>
						</div>
						</div>
					</div>
				</div>
				<div class="tab-pane fade" id="pills-returns" role="tabpanel" aria-labelledby="pills-returns-tab">				
					<div id="accordion">			
						<div v-for="(_return,index) in returns" :key="index" class="card rounded mb-3">
							<div class="card-header bg-white rounded" :id="`heading_${index}`">
							<div class="d-flex justify-content-between">								
								<div class="d-flex flex-column">
									<small>date</small>
									{{_return.date | dateformat}}
								</div>	
								<div class="d-flex flex-column">
									<small>return ID</small>
									<button class="btn btn-link collapsed dropdown-toggle" data-toggle="collapse" :data-target="`#collapse_${index}`" aria-expanded="false" :aria-controls="`collapse_${index}`">
										{{_return.id}}
									</button>
								</div>									
								<div class="d-flex flex-column">
									<small>sale ID</small>
									<router-link
										:to="{ name: 'saleDetail', params: { sale_id: _return.sale_id }}">			
										{{_return.sale_id}}
									</router-link>
								</div>								
							</div>
							</div>
							<div :id="`collapse_${index}`" class="collapse" :aria-labelledby="`heading_${index}`" data-parent="#accordion">
							<div class="card-body">
								<div>							
									<table class="table table-borderless">													
										<thead>
											<tr>																										
											<th scope="col">Product</th>
											<th scope="col">State</th>
											<th scope="col">Quantity</th>																										
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item,index) in _return.items" :key="index">																											
												<td>{{item.product_name}}</td>
												<td>{{item.state}}</td>
												<td>{{item.quantity | intcomma}}</td>															
											</tr>												
										</tbody>
									</table>
								</div>
							</div>
							</div>
						</div>
					</div>				
				</div>
				<div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">...</div>
			</div> 		  
		</div>	
    </div>
</template>
<script>
	export default {
    name: 'pos',
    props: {
        msg: String
    },
    data(){
        return{
			pageNumber: 0,  // default to page 1
            size:100, 
			search: '',
			sales:null,
			//returns
			returns:null,
			customers: null,
			date_range:0,
			from_date: null,
			to_date: null,
			//receipt modal.
			receipt_modal_data:null,
        }
	},
	computed:{     
		account_switched(){
			return this.$store.state.account_switch_count
		},
		new_sale(){
			return this.$store.state.new_sale_count
		}, 
        pageCount(){		
            let l = this.sales.length,
                s = this.size;
            return Math.ceil(l/s);
        },
        paginatedData(){                        
            const start = this.pageNumber * this.size,
            end = start + this.size
            if (! this.search.length){                                
                return this.sales.slice(start, end)
            }            
            else{      			                                    
                var filtered_list = this.sales.filter((s)=>{					
					//get products matching search query
					var products = s.products.filter((p)=>{
						return p.name.toUpperCase().includes(this.search.toUpperCase())
					})
					//get sales containing product.
					for (var product of products){
						var sales = this.sales.filter((s)=>{
							return s.products.includes(product)
						})
					}
					return sales
                })
                return filtered_list.slice(start, end);
            }
        }
    },
    mounted(){		
		this.from_date = this.$moment().subtract(this.date_range, 'days').format('YYYY-MM-DD')
        this.to_date = this.$moment().format('YYYY-MM-DD')
		this.getSales()
		this.getCustomers()
	},
	watch:{		
		account_switched: function(){
			this.getSales()
			this.getCustomers()
		},
		new_sale: function(){
			this.getSales()
		},
		date_range: function(){
			if (this.date_range){
				this.from_date = this.$moment().subtract(this.date_range, 'days').format('YYYY-MM-DD')
				this.to_date = this.$moment().format('YYYY-MM-DD')
				this.getSales()
			}
		},
		search: function(){
            if (this.search){
                this.pageNumber = 0
            }            
        }
	},
    methods:{
		nextPage(){
            this.pageNumber++
        },
        prevPage(){
            this.pageNumber--
        },  	        
		//get sales by user		
		getSales:function(){
			//convert date to unix timestamp
			this.sales = null
			this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/list-sales`,
				params:{
					date0: this.from_date,
					date1: this.to_date
				},
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                }
            }).then((response)=>{							
                this.sales = response.data		
            }).catch((err)=>{
                this.$emit('alert',err)
            })
		},
		getReturns:function(){
			this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/returns`,
				params:{
					date0: this.from_date,
					date1: this.to_date
				},
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                }
            }).then((response)=>{							
                this.returns = response.data		
            }).catch((err)=>{
                this.$emit('alert',err)
            })
		},
		getCustomers: function(){                        
            this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/customers/`,
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                },            
            }).then((response)=>{
                this.customers = response.data
            }).catch((err)=>{
                this.$emit('alert',err)
            })
		},
		totalItems: function(products){
			var total = 0
			for (var i in products){				
				total += parseInt(products[i].qty)
			}
			return total
		},
		totalCost: function(products){
			var total = 0.00
			for (var i in products){				
				total += parseFloat(products[i].total)
			}
			return total
		},
		totalPayment: function(payments){
			var total = 0.00
			for (var i in payments){
				total += parseFloat(payments[i].amount)
			}
			return total
		},
		openReceipt: function(sale){
			//create modal data
			this.receipt_modal_data = sale
			//open modal
			var button = document.getElementById('receipt-modal-button')
			button.click()
		}
    }
}
</script>